module.exports = __webpack_public_path__ + "img/胡状镇.6c9d64d7.png";